/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Components.Controls {
    "use strict";

    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;

    interface IClientModel {
        id: string | Guid,
        displayName: string,
        firstName: string,
        lastName: string
    }
    
    interface IClientMoverController {
        securityAccess: SecurityAccessEnum;
        ngModel: angular.INgModelController;
        clientInfo: any[];
        
        disabled: boolean;
        securityDisabled: boolean;
        
        selected: IClientModel[];

        initModelValue: any;
        isNullValue: boolean;

        init(): void;
        select(): void;
        deselect(client: IClientModel): void;
        setModelValue(): void;
        toggleAllClients(): void;
        maxClient: number;
        minClient: number;
    }

    export class ClientListSelectorController implements IClientMoverController {
        static $inject = [
            '$scope',
            '$q',
            'meevo.components.modal.ModalService',
            "$translate"
        ];

        securityAccess: SecurityAccessEnum;

        // comes from directive's link function
        ngModel: angular.INgModelController;
        defaultValue: any;
        currentClient: IClientModel = null;
        selected: IClientModel[] = [];
        clientInfo: any[];

        initModelValue: any = [];
        isNullValue: boolean = true;

        disabled: boolean;
        securityDisabled: boolean = false;
        maxClient: number;
        minClient: number;
        
        isAllClientsVisible: boolean;
        allClients: boolean;

        minClientErrorMessageKey: string;

        constructor(
            private $scope: angular.IScope,
            private $q: angular.IQService,
            private modalService: Meevo.Components.Modal.IModalService,
            public $translate: angular.translate.ITranslateService
        ) {}

        init(): void {
            if (this.securityAccess === SecurityAccessEnum.Grant) {
                if (this.defaultValue && this.defaultValue.length > 0) {
                    this.defaultValue.forEach((value) => {
                        if (this.clientInfo) {
                            for (var i = 0; i < this.clientInfo.length; i++) {
                                if (this.clientInfo[i].id == value)
                                    this.selected.push(this.clientInfo[i]);
                            }
                        }
                        else {
                            this.selected.push(value);
                        }
                    });
                }
                this.setModelValue();
            } else {
                this.securityDisabled = true;
            }

            this.minClientErrorMessageKey = this.isAllClientsVisible
            ? "MESSAGE_ALL_CLIENTS_SELECTOR_CHOOSE_CLIENT_OR_ALL"
            : "MESSAGE_ALL_CLIENTS_SELECTOR_CHOOSE_CLIENT";
        }

        select(): void {
            if (this.selected.length == this.maxClient) {
                let message = this.$translate.instant("LABEL_MAX_SELECTED_CLIENTS", {
                    NumberOfClient: this.maxClient
                });
                this.modalService.alert(message);

                return;
            } 
            if (this.currentClient) {
                this.selected.push(this.currentClient);
                this.clientInfo = this.selected;
                this.setModelValue();
                this.currentClient = null;
            }
        };

        deselect(client: IClientModel): void {
            if (!this.disabled) {
                let index = this.selected.indexOf(client, 0)

                if (index > -1) {
                    this.selected.splice(index, 1);
                    this.clientInfo = this.selected;
                    this.setModelValue();
                }
            }
        };

        setModelValue(): void {
            let modelValue: Array<string | Guid>;

            this.isNullValue = !this.selected.length;

            if (this.isNullValue) {
                modelValue = this.initModelValue;
            } else {
                modelValue = this.selected.map((e: IClientModel) => e.id);
            }

            this.ngModel.$setViewValue(modelValue);
        }

        toggleAllClients(): void {
            if (this.allClients) {
                this.selected = [];
                this.setModelValue();
            }
        }

        get invalid(): boolean {
            return (
              (this.minClient && this.selected.length < this.minClient) ||
              (this.maxClient && this.selected.length > this.maxClient)
            );
          }
    }
}